import { createAction, props } from '@ngrx/store';
import { IPayrollCalendarRequest } from '../models/payroll-calendar-request.model';

export const loadPayrollDays = createAction('[PaymentRuns] Load PayrollDays', props<{ request: { businessId: string; year: number } }>());

export const loadPayrollDaysSuccess = createAction('[PaymentRuns] Load PayrollDays Success', props<{ response: any }>());

export const loadPayrollDaysFailure = createAction('[PaymentRuns] Load PayrollDays Failure', props<{ error: Error | any }>());

export const savePayrollDays = createAction(
  '[PaymentRuns] Load SavePayrollDays',
  props<{ request: { businessId: string; model: IPayrollCalendarRequest } }>()
);

export const savePayrollDaysSuccess = createAction('[PaymentRuns] Load SavePayrollDays Success', props<{ response: string }>());

export const savePayrollDaysFailure = createAction('[PaymentRuns] Load SavePayrollDays Failure', props<{ error: Error | any }>());
